// @ts-nocheck
import { __, sprintf } from '@wordpress/i18n';
import { InspectorControls, useBlockProps } from '@wordpress/block-editor';
import { SelectControl, PanelBody } from '@wordpress/components';

const { forms = [] } = window.zigaformData || {};

export default function Edit({ attributes, setAttributes }) {
    const { formId = 0 } = attributes;
    const blockProps = useBlockProps();
    const selectedForm = forms.find((f) => parseInt(f.id, 10) === parseInt(formId, 10));
    return (
        <div {...blockProps}>
            <InspectorControls>
                <PanelBody title={ __('Form Settings', 'FRocket_admin') }>
                    <SelectControl
                        label={ __('Select Form', 'FRocket_admin') }
                        value={ formId }
                        options={[
                            { label: __('— Select —', 'FRocket_admin'), value: 0 },
                            ...forms.map((f) => ({ label: f.name, value: f.id })),
                        ]}
                        onChange={(value) => setAttributes({ formId: parseInt(value, 10) })}
                    />
                </PanelBody>
            </InspectorControls>

            <p>
                {formId && selectedForm ? (
                    <>
                        {sprintf(__('Form #%d — ', 'FRocket_admin'), formId)}
                        <strong>{selectedForm.name}</strong>
                        {__(' will be displayed on the front-end.', 'FRocket_admin')}
                    </>
                ) : (
                    __('Select a form in the sidebar →', 'FRocket_admin')
                )}
            </p>

        </div>
    );
}
